import { render, staticRenderFns } from "./checkInfo.vue?vue&type=template&id=21cb38a4&scoped=true"
import script from "./checkInfo.vue?vue&type=script&lang=js"
export * from "./checkInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cb38a4",
  null
  
)

export default component.exports